
import { defineComponent } from 'vue';
import vClickOutside from 'v-click-outside';

export default defineComponent({
  data: () => ({
    open: false,
  }),
  directives: {
    'on-click-outside': vClickOutside,
  },
  computed: {
    activeValue(): string {
      return this.$store.getters['order/preferredWarehouse'];
    },
    activeLabel(): string {
      const activePreferredWarehouse =
        this.$store.getters['order/activePreferredWarehouse'];
      return this.$store.getters['order/getWarehouseLabel'](
        activePreferredWarehouse,
      );
    },
    disabled(): boolean {
      return this.$store.getters['order/orderLockedWarehouse'] !== '';
    },
    warehouses(): { key: string; value: string }[] {
      return Object.entries(this.$store.getters['order/availableWarehouses'])
        .map(([key, value]) => ({
          key,
          value: value as string,
        }))
        .sort((a, b) => a.value.localeCompare(b.value));
    },
  },
  methods: {
    setValue(key: string): void {
      const value = key !== this.activeValue ? key : '';
      this.$store.dispatch('order/setPreferredWarehouseFromSelect', value);
      this.closeFilter();
    },
    closeFilter(): void {
      this.open = false;
    },
  },
});
